// extracted by mini-css-extract-plugin
export default {"searchBarMultiple":"styles_searchBarMultiple__I9Vrh","search":"styles_search__mutfH","searchButton":"styles_searchButton__hyQcV","text":"styles_text__EM1io"};